import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import moment from 'moment';
import Validator from 'validatorjs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  Form,
  Button,
  Modal,
  Icon,
  Message,
  Input,
  Table,
  Header,
} from 'semantic-ui-react';
import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';
import REGEX from '../../constants/regexPatterns';

class EditOfferBatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      auctionAccessNo: '',
      salesRepEmail: '',
      emails: '',
      expirationDate: '',
      name: '',
      cellPhone: '',
      userEmail: '',
      acceptedOnBehalfOf: '',
      errors: {},
      flatRateOffers: [],
      approved: false,
      rejected: false,
    };
  }

  componentDidMount() {
    const { flatRateOfferBatch } = this.props;
    if (!isEmpty(flatRateOfferBatch)) {
      const {
        id,
        auctionAccessNo,
        buyerInformation: { emails, name, cellPhone },
        userEmail,
        salesRepEmail,
        expirationDate,
        flatRateOffers,
        approved,
        rejected,
      } = flatRateOfferBatch;

      this.setState({
        id: parseInt(id, 10),
        auctionAccessNo,
        emails,
        name,
        cellPhone,
        salesRepEmail,
        expirationDate,
        userEmail,
        flatRateOffers,
        approved,
        rejected,
      });
    }
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      onAcceptHandler,
      onRejectHandler,
      error,
      submitting,
      resetForm,
      flatRateOfferBatch: { state },
    } = this.props;

    const {
      errors,
      auctionAccessNo,
      emails,
      name,
      cellPhone,
      salesRepEmail,
      expirationDate,
      userEmail,
      flatRateOffers,
      acceptedOnBehalfOf,
      approved,
      rejected,
      id,
    } = this.state;

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onDateChangeHandler = field => date => {
      this.setState({ [field]: moment(date, 'YYYY-MM-DD HH:mm:ss') });
    };

    const validationRules = {
      auctionAccessNo: 'required|numeric',
      emails: ['required', 'regex:' + REGEX.MULTIPLE_EMAILS],
      salesRepEmail: ['required', 'regex:' + REGEX.MULTIPLE_EMAILS],
    };

    const acceptHandler = () => {
      if (isEmpty(acceptedOnBehalfOf)) {
        this.setState({
          errors: {
            acceptedOnBehalfOf: 'The Accepting on behalf of field is required.',
          },
        });
        return false;
      }
      onAcceptHandler({
        id: parseInt(id, 10),
        acceptedOnBehalfOf,
      });
      this.setState({ errors: {} });
      return true;
    };

    const rejectHandler = () => {
      onRejectHandler({
        id: parseInt(id, 10),
      });
    };

    const submitForm = () => {
      const trimmedAuctionAccessNo = auctionAccessNo.trim();
      const stateForValidation = { ...this.state, auctionAccessNo: trimmedAuctionAccessNo };
      const validation = new Validator(stateForValidation, validationRules);
      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        id: parseInt(id, 10),
        emails,
        name,
        cellPhone,
        FlatRateOfferBatch: {
          auctionAccessNo: trimmedAuctionAccessNo,
          salesRepEmail,
          userEmail,
          expirationDate: dateTimeFormatted(utcMoment(expirationDate)),
        },
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Edit Dealshield 360 offer</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              {!resetForm && (
                <Form.Group widths='equal'>
                  <Form.Field required error={!isEmpty(errors.auctionAccessNo)}>
                    <label htmlFor='auctionAccessNo'>Auction access number</label>
                    <Input
                      id='auctionAccessNo'
                      placeholder='Auction Access Number'
                      name='auctionAccessNo'
                      value={auctionAccessNo}
                      onChange={onChangeHandler('auctionAccessNo')}
                    />
                    {errors.auctionAccessNo && (
                      <span>{errors.auctionAccessNo}</span>
                    )}
                  </Form.Field>
                  <Form.Field required error={!isEmpty(errors.expirationDate)}>
                    <label htmlFor='expirationDate'>Expiration Date</label>
                    <div id='expirationDate'>
                      <DatePicker
                        style={{ padding: '0', width: '100%' }}
                        selected={utcMoment(expirationDate)}
                        onChange={onDateChangeHandler('expirationDate')}
                        showTimeSelect
                        timeFormat='HH:mm'
                        timeIntervals={15}
                        dateFormat='YYYY-MM-DD HH:mm:ss ZZ'
                      />
                    </div>
                    {errors.expirationDate && (
                      <span>{errors.expirationDate}</span>
                    )}
                  </Form.Field>
                </Form.Group>
              )}

              {resetForm && (
                <Form.Group widths='equal'>
                  <Form.Field required error={!isEmpty(errors.name)}>
                    <label htmlFor='name'>Dealer Name</label>
                    <Input
                      id='name'
                      placeholder='Dealer Name'
                      name='name'
                      value={name}
                      onChange={onChangeHandler('name')}
                    />
                    {errors.name && <span>{errors.name}</span>}
                  </Form.Field>
                  <Form.Field required error={!isEmpty(errors.cellPhone)}>
                    <label htmlFor='cellPhone'>Dealer Phone #:</label>
                    <Input
                      id='cellPhone'
                      placeholder='Dealer Phone #:'
                      name='cellPhone'
                      value={cellPhone}
                      onChange={onChangeHandler('cellPhone')}
                    />
                    {errors.cellPhone && <span>{errors.cellPhone}</span>}
                  </Form.Field>
                </Form.Group>
              )}

              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.emails)}>
                  <label htmlFor='emails'>Emails</label>
                  <Input
                    id='emails'
                    placeholder='Emails'
                    name='emails'
                    value={emails}
                    onChange={onChangeHandler('emails')}
                  />
                  {errors.emails && <span>{errors.emails}</span>}
                </Form.Field>
                <Form.Field required error={!isEmpty(errors.salesRepEmail)}>
                  <label htmlFor='salesRepEmail'>Sales Rep Email</label>
                  <Input
                    id='salesRepEmail'
                    placeholder='Sales Rep Email'
                    name='salesRepEmail'
                    value={salesRepEmail}
                    onChange={onChangeHandler('salesRepEmail')}
                  />
                  {errors.salesRepEmail && <span>{errors.salesRepEmail}</span>}
                </Form.Field>
              </Form.Group>
              {resetForm && (
                <Form.Group widths='equal'>
                  <Form.Field required error={!isEmpty(errors.userEmail)}>
                    <label htmlFor='userEmail'>
                      Please provide an email address to receive updates on this
                      offer
                    </label>
                    <Input
                      id='userEmail'
                      placeholder='Dealer Name'
                      name='userEmail'
                      value={userEmail}
                      onChange={onChangeHandler('userEmail')}
                    />
                    {errors.userEmail && <span>{errors.userEmail}</span>}
                  </Form.Field>
                </Form.Group>
              )}

              {!resetForm
                && !approved
                && !rejected && (
                  <Form.Group widths='equal'>
                    <Form.Field
                      required
                      error={!isEmpty(errors.acceptedOnBehalfOf)}
                    >
                      <label htmlFor='acceptedOnBehalfOf'>Accepting on behalf of</label>
                      <Input
                        id='acceptedOnBehalfOf'
                        placeholder='Accepting on behalf of'
                        name='acceptedOnBehalfOf'
                        value={acceptedOnBehalfOf}
                        onChange={onChangeHandler('acceptedOnBehalfOf')}
                      />
                      {errors.acceptedOnBehalfOf && (
                        <span>{errors.acceptedOnBehalfOf}</span>
                      )}
                    </Form.Field>
                    <Form.Field required error={!isEmpty(errors.userEmail)}>
                      {!submitting
                        && id && (
                          <div className='accept-reject-button'>
                            <Button
                              color='green'
                              onClick={acceptHandler}
                              inverted
                            >
                              <Icon name='checkmark' /> Accept
                            </Button>
                            <Button
                              color='red'
                              onClick={rejectHandler}
                              inverted
                            >
                              Reject
                            </Button>
                          </div>
                      )}
                    </Form.Field>
                  </Form.Group>
              )}
            </Form>
            <br />
            <br />
            <Header>Offers in this batch</Header>
            <Table celled padded size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell singleLine textAlign='center'>
                    5m#
                  </Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Miles</Table.HeaderCell>
                  <Table.HeaderCell>PSI</Table.HeaderCell>
                  <Table.HeaderCell>Accepted User</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {map(flatRateOffers, flatRateOffer => (
                  <Table.Row key={flatRateOffer.id}>
                    <Table.Cell>{flatRateOffer.dealerNo}</Table.Cell>
                    <Table.Cell>{flatRateOffer.price}</Table.Cell>
                    <Table.Cell>{flatRateOffer.milesSelected}</Table.Cell>
                    <Table.Cell>
                      {flatRateOffer.psiEligible && (
                        <Icon color='green' name='checkmark' size='large' />
                      )}
                      {!flatRateOffer.psiEligible && (
                        <Icon color='red' name='close' size='large' />
                      )}
                    </Table.Cell>
                    <Table.Cell>{flatRateOffer.acceptingUserName}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}

          {!submitting
            && state !== 'void'
            && id && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Update
              </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

EditOfferBatch.propTypes = {
  flatRateOfferBatch: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    auctionAccessNo: PropTypes.string,
    buyerInformation: PropTypes.shape({
      emails: PropTypes.string,
      name: PropTypes.string,
      cellPhone: PropTypes.string,
    }),
    userEmail: PropTypes.string,
    salesRepEmail: PropTypes.string,
    expirationDate: PropTypes.string,
    flatRateOffers: PropTypes.array,
    approved: PropTypes.bool,
    rejected: PropTypes.bool,
    state: PropTypes.string,
  }),
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  onAcceptHandler: PropTypes.func,
  onRejectHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  resetForm: PropTypes.bool,
};

export default EditOfferBatch;
